<cyborg-error-message class="error" *ngIf="error$ | async; else results">
  <strong>HUNTER has encountered an error.</strong> Please try again or contact
  <a routerLink="/customer-support">support</a>.
</cyborg-error-message>
<ng-template #results>
  <div *ngIf="stagedHuntPackages$ | async as stagedHuntPackages">
    <div *ngIf="deployedHuntPackages$ | async as deployedHuntPackages">
      <div *ngIf="outdatedHuntPackages$ | async as outdatedHuntPackages">
        <cyborg-section
          *ngIf="
            stagedHuntPackages && deployedHuntPackages && outdatedHuntPackages;
            else loading
          "
          id="deployment-queue"
          class="charts"
        >
          <div class="row">
            <div class="col-12 col-lg-6 chart small">
              <div class="inner">
                <span>Queued Hunt Packages</span>
                <div class="recent">
                  <div class="count">
                    {{ stagedHuntPackages.meta.totalItems }}<br />
                    <span>Staged</span>
                  </div>
                  <div class="count">
                    {{ deployedHuntPackages.meta.totalItems }}<br />
                    <span>Deployed</span>
                  </div>
                  <div class="count">
                    {{ outdatedHuntPackages.meta.totalItems }}<br />
                    <span>Outdated</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4 chart small">
              <div class="inner">
                <span>Bookmarked Hunt Packages</span>
                <div class="recent">
                  <div class="count">
                    {{ bookmarkedHuntPackages }}<br />
                    <span>Hunt Packages</span><br />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <cyborg-section-title>
            <div class="logo">
              <span>Hunt Package Deployment Queue</span>
            </div>
          </cyborg-section-title>

          <kendo-tabstrip>
            <kendo-tabstrip-tab title="Staged Hunt Packages" [selected]="first">
              <ng-template kendoTabContent>
                <deployment-queue
                  *ngFor="let dep of stagedHuntPackages.items"
                  [deployItem]="dep"
                  (onMarkForDeployedEvent)="onMarkForDeployedEvent()"
                ></deployment-queue>
                <kendo-datapager
                  [style.width.%]="100"
                  [pageSize]="pageSize"
                  [skip]="stagedSkip"
                  [total]="stagedHuntPackages.meta.totalItems"
                  [pageSizeValues]="false"
                  (pageChange)="onStagedPageChange($event)"
                >
                </kendo-datapager>
              </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab
              title="Deployed Hunt Packages"
              [selected]="second"
            >
              <ng-template kendoTabContent>
                <deployment-queue
                  *ngFor="let dep of deployedHuntPackages.items"
                  [deployItem]="dep"
                  (onMarkForDeployedEvent)="onMarkForDeployedEvent()"
                ></deployment-queue>
                <kendo-datapager
                  [style.width.%]="100"
                  [pageSize]="pageSize"
                  [skip]="deployedSkip"
                  [total]="deployedHuntPackages.meta.totalItems"
                  [pageSizeValues]="false"
                  (pageChange)="onDeployedPageChange($event)"
                >
                </kendo-datapager>
              </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [selected]="third">
              <ng-template kendoTabTitle>
                <span
                  [matBadge]="outdatedHuntPackages.items.length"
                  matBadgeColor="warn"
                  matBadgeOverlap="false"
                  >Outdated Hunt Packages</span
                >
              </ng-template>
              <ng-template kendoTabContent>
                <deployment-queue
                  *ngFor="let dep of outdatedHuntPackages.items"
                  [deployItem]="dep"
                  (onMarkForDeployedEvent)="onMarkForDeployedEvent()"
                ></deployment-queue>
                <kendo-datapager
                  [style.width.%]="100"
                  [pageSize]="pageSize"
                  [skip]="outdatedSkip"
                  [total]="outdatedHuntPackages.meta.totalItems"
                  [pageSizeValues]="false"
                  (pageChange)="onOutdatedPageChange($event)"
                >
                </kendo-datapager>
              </ng-template>
            </kendo-tabstrip-tab>
          </kendo-tabstrip>
        </cyborg-section>
      </div>
    </div>
  </div>
</ng-template>
<cyborg-modal-deploy id="deploy" class="modal"></cyborg-modal-deploy>
<ng-template #loading>
  <div class="loading">
    <kendo-loader type="pulsing" themeColor="primary" size="large">
    </kendo-loader>
  </div>
</ng-template>
